"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _uiLibrary = require("@printdeal/ui-library");
var _dataLayerManager = require("@printdeal/data-layer-manager");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var TogglePasswordButton = function TogglePasswordButton(_ref) {
  var setShowPassword = _ref.setShowPassword,
    showPassword = _ref.showPassword,
    buttonLocation = _ref.buttonLocation,
    eventCategory = _ref.eventCategory,
    eventLabel = _ref.eventLabel;
  var handleOnClick = function handleOnClick() {
    var currentEventLabel = eventLabel || JSON.stringify({
      setVisibilityPassword: showPassword,
      buttonLocation: buttonLocation
    });

    // GA3
    (0, _dataLayerManager.addDataLayerEntry)(_dataLayerManager.Events.Event, {
      gaEvent: {
        eventCategory: eventCategory,
        eventAction: 'toggle_password_visibility',
        eventLabel: currentEventLabel,
        eventNonInteraction: false
      }
    });

    // GA4
    (0, _dataLayerManager.addDataLayerEntry)(eventCategory, {
      eventAction: 'toggle_password_visibility',
      eventLabel: currentEventLabel,
      eventNonInteraction: false
    });
    setShowPassword(!showPassword);
  };
  return /*#__PURE__*/_react["default"].createElement("button", {
    id: "password-visibility-toggle",
    role: "switch",
    type: "button",
    "aria-checked": showPassword ? 'true' : 'false',
    onClick: handleOnClick
  }, /*#__PURE__*/_react["default"].createElement(_uiLibrary.Icon, {
    icon: showPassword ? 'eye-closed' : 'eye',
    size: 4
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "pd-sr-only"
  }, showPassword ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "account.form.password.screenReader.hidePassword",
    defaultMessage: "Hide password"
  }) : /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "account.form.password.screenReader.showPassword",
    defaultMessage: "Show password"
  })));
};
TogglePasswordButton.defaultProps = {
  eventLabel: undefined
};
TogglePasswordButton.propTypes = {
  /** Function to show or hide the password */
  setShowPassword: _propTypes["default"].func.isRequired,
  /** Show password, true or false */
  showPassword: _propTypes["default"].bool.isRequired,
  /** String describing the location of the password toggle (registration or login) */
  buttonLocation: _propTypes["default"].string.isRequired,
  /** Event category */
  eventCategory: _propTypes["default"].string.isRequired,
  /** Event label */
  eventLabel: _propTypes["default"].string
};
var _default = exports["default"] = TogglePasswordButton;